import { ServiceRequest } from "../../../../types/service.type";
import { ServiceRequestTypeEnum } from "../../../../enum/service.enum";

import CreateContract from "./CreateContract";
import ContractDetails from "./ContractDetails";
import ProviderWithoutContract from "./ProviderWithoutContract";

const ContractTab = ({
  serviceRequest,
  isServiceRequestLoading,
  handleSetIsContractPaid,
}: {
  serviceRequest?: ServiceRequest;
  isServiceRequestLoading: boolean;
  handleSetIsContractPaid: (isContractPaid: boolean) => void;
}) => {
  const isProvider = serviceRequest?.type === ServiceRequestTypeEnum.received;
  const hasContract = Boolean(serviceRequest?.contractId);

  if (isServiceRequestLoading) return null;

  if (isProvider && !hasContract) return <ProviderWithoutContract />;
  if (hasContract)
    return <ContractDetails serviceRequest={serviceRequest!} handleSetIsContractPaid={handleSetIsContractPaid} />;
  return <CreateContract serviceRequest={serviceRequest} isServiceRequestLoading={isServiceRequestLoading} />;
};

export default ContractTab;
